// Generated by scripts/build-info.mjs - do not edit, not committed.
export const BUILD_INFO = {
  sha: '0a11d0824b0c3aa35940116fc7e285d096bdc883',
  short: '0a11d08',
  builtAt: '2026-11-04T07:47:31.466Z',
} as const;
